import { Button, Card, CardActions, CardContent, CardHeader, CardMedia, Grid, Typography } from "@mui/material";
import React from "react";
import CardDialog from "./CardDialog";

const NewsCard = ({ header, image, text }) => {

    const [showDialogMenu, togleDialogMenu] = React.useState(false);

    return <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
        <Card sx={{
            height: 515,
            width: "100%",
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        }}>

            <CardHeader
                sx={{ height: 80 }}
                title={<Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: "2",
                        WebkitBoxOrient: "vertical",
                    }}
                >
                    {header}
                </Typography>}
            />

            <CardMedia sx={{ height: 250 }} image={image} />

            <CardContent>
                <Typography
                    sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: "3",
                        WebkitBoxOrient: "vertical",
                    }}
                >
                    {text}
                </Typography>
            </CardContent>

            <CardActions sx={{ justifyContent: "center" }}>
                <Button onClick={() => togleDialogMenu(true)} size="small">Подробнее ... </Button>
            </CardActions>

            <CardDialog
                open={showDialogMenu}
                onClose={() => togleDialogMenu(false)}
                title={header}
                text={text}
            />

        </Card>
    </Grid>
}

export default NewsCard;